import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import ToastMessage from "../utils/toasts/toastMessage";
import Loader from "../utils/loader/loader";
import { POST_FORGOT_PASSWORD } from "./../utils/api";
const ForgotPassword = () => {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [successText, setSuccessText] = useState(false);
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });

  const [email, setEmail] = useState("");

  const handleEmailInput = (e) => {
    setEmail(e.target.value);
  };

  const handleSend = async () => {
    if (!email) {
      setToastState({
        show: true,
        message: "Email is required!",
        type: "error",
      });
      return;
    }

    setLoading(true);

    try {
      const payload = {
        email: email,
      };

      const resp = await axios.post(POST_FORGOT_PASSWORD, payload, {
        headers: { "Content-Type": "application/json" },
      });

      if (resp.status === 200) {
        setSuccessText(true);
      }
    } catch (err) {
      setToastState({
        show: true,
        message: err?.response?.data?.detail || "Please signup first!",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="auth-main">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="w-100 auth-content">
              <div className="pt-4 auth-content__graphics">
                <img
                  src="./assets/images/inner-pages/auth-side-image.png"
                  alt=""
                  className="main-img"
                />
                <img
                  src="./assets/images/inner-pages/auth-side-prop01.png"
                  alt=""
                  className="anim-up-down side-prop side-prop01"
                />
                <img
                  src="./assets/images/inner-pages/auth-side-prop02.png"
                  alt=""
                  className="anim-up-down side-prop side-prop02"
                />
                <img
                  src="./assets/images/inner-pages/auth-side-shield03.png"
                  alt=""
                  className="anim-up-down side-prop side-prop03"
                />
              </div>
              <img
                src="./assets/images/JigyaasuBlackLogo.svg"
                alt=""
                className="logo-img"
              />
              <div className="auth-content__right">
                <div className="ff-poppins curved-block curved-block--login">
                  <div className="top-white"></div>
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      handleSend();
                    }}
                  >
                    <div className="middle-white">
                      <h1 className="fw700 fz56 primaryText">
                        Generate password link
                      </h1>
                      <p className="fz20"></p>

                      <div className="middle-white__inner">
                        <div className="form-group">
                          <label htmlFor="email" className="fw500 fz16 label">
                            Email
                          </label>
                          <input
                            type="email"
                            className="fz16 form-control"
                            name="email"
                            onChange={handleEmailInput}
                          />
                          {successText && (
                            <div
                              style={{
                                color: "#28a745",
                                fontSize: "14px",
                                marginTop: "3px",
                              }}
                            >
                              <img src="./assets/images/inner-pages/icons/icon-tickmark--greenBg.svg" />{" "}
                              A password reset link has been sent to your email
                              address.
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="bottom-white">
                      <div className="bottom-white__left"></div>
                      <div className="bottom-white__right">
                        <button
                          type="submit"
                          className="btn btn-solid btn-solid--dark btn-auth"
                        >
                          <span className="fw500">Send</span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Loader show={loading} />
      <ToastMessage
        show={toastState.show}
        onClose={() => setToastState({ show: false, message: "", type: "" })}
        message={toastState.message}
        type={toastState.type}
      />
    </section>
  );
};

export default ForgotPassword;
